<template>
  <div class="todo-center">
    <el-container>
      <el-aside width="240px" :style="'background:' + themeStyle.background">
        <div class="title">待办</div>
        <el-menu
          :default-active="curMenu"
          @select="selectMenu"
          :class="themeStyle.menu"
          :style="'background:' + themeStyle.background"
        >
          <el-menu-item index="verify">
            <template slot="title">
              <svg-icon icon-class="todo_verify" class="icon"></svg-icon>
              <span class="label">我的审批</span>
            </template>
          </el-menu-item>
          <el-menu-item index="favorite">
            <template slot="title">
              <svg-icon icon-class="todo_favorite" class="icon"></svg-icon>
              <span class="label">我的收藏</span>
            </template>
          </el-menu-item>
          <el-menu-item index="task">
            <template slot="title">
              <svg-icon icon-class="todo_task" class="icon"></svg-icon>
              <span class="label">我的任务</span>
            </template>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main>
        <verify v-if="curMenu === 'verify'"></verify>
        <favorite v-else-if="curMenu === 'favorite'"></favorite>
        <task-list
          ref="taskList"
          v-else-if="curMenu === 'task'"
          from="todoList"
          @hook:mounted="$refs.taskList.init()"
        ></task-list>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { themeStyleMap } from "@/views/Company/Todo/static"
import Verify from "./Verify"
import Favorite from "@/views/Company/Todo/Favorite"
import TaskList from "@/views/Front/Project/TaskList"

export default {
  name: "TodoCenter",
  components: { Verify, Favorite, TaskList },
  data() {
    return {
      themeStyleMap,
      curMenu: "verify"
    }
  },
  computed: {
    theme() {
      return this.$store.getters.theme
    },
    themeStyle() {
      return this.themeStyleMap[this.theme]
    }
  },
  methods: {
    selectMenu(menu) {
      this.curMenu = menu
    }
  }
}
</script>

<style lang="scss" scoped>
.todo-center {
  height: 100%;
  .el-container {
    height: 100%;
    background: #ffffff;
    .el-aside {
      display: flex;
      flex-flow: column;
      border-right: solid 1px #e6e6e6;
      .title {
        color: #313132;
        font-size: 18px;
        margin: 20px;
      }
      .el-menu {
        flex: 1;
        border-right: unset;
        .el-menu-item {
          height: 40px;
          line-height: 40px;
          display: flex;
          align-items: center;
          padding-left: 18px;
          .icon {
            font-size: 16px;
          }
          .label {
            color: #313132;
            margin-left: 10px;
          }
          &.is-active {
            .label {
              color: #1989fa;
            }
          }
        }
      }
      .standard {
        .el-menu-item {
          &.is-active {
            background-color: #e4e7ed;
          }
        }
      }
      .simple {
        .el-menu-item {
          &.is-active {
            background-color: #f6f8fa;
          }
        }
      }
    }
    .el-main {
      padding: 0;
    }
  }
}
</style>
<style lang="scss"></style>
